import React, { useState } from 'react'
import useTrans from '@hooks/useTrans'
import useFindMenu from '@hooks/useFindMenu'
import { getIcon } from '@utils/icons'
import { ChevronDown } from '@components/icons'
import { Logo, WContainer, WLink } from '@components/atoms'
import styles from './Footer.module.sass'
import { useRouter } from 'next/router'
import { handleFooterTracking, handleSocialTracking } from '@utils/tracking'

interface Props {
  className?: string
}

const Footer = (props: Props) => {
  const { className = '' } = props

  const t = useTrans()
  const router = useRouter()

  const footerMenu = useFindMenu('footer')
  const socialMenu = useFindMenu('social')

  return (
    <footer className={`${styles.root} ${className}`}>
      <div className={styles.main}>
        <WContainer>
          <div className={styles.mainLayout}>
            <div className={styles.left}>
              <WLink href={'/'} className={styles.logo}>
                <Logo />
              </WLink>
              <div className={styles.divider} />

              {footerMenu?.children.map((x, index) => (
                <div key={x.pk} className={`${styles.col} ${styles.footerMenusDesk}`}>
                  <div className={`${styles.menu}`}>
                    <div className={styles.menuTitle}>
                      <span
                        className={`${styles.menuTitleLabel} ${styles['menuTitleLabel--mobile']}`}
                      >
                        {x.name}
                      </span>
                    </div>
                    <div
                      id={`footermenu_${x.pk}_panel`}
                      aria-labelledby={`footermenu_${x.pk}_trigger`}
                      className={styles.menuPanel}
                    >
                      <ul className={styles.menuList}>
                        {x.children?.map((y) => (
                          <li key={y.pk}>
                            <WLink
                              href={y.url}
                              onClick={() => handleFooterTracking(y.key, x.key)}
                              newPage={y.blank}
                              className={styles.menuItem}
                            >
                              {y.name}
                            </WLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {!!socialMenu?.children?.length && (
              <ul className={styles.socialMenu}>
                {socialMenu.children.map((x) => (
                  <li key={x.pk}>
                    <WLink
                      href={x.url}
                      className={styles.socialItem}
                      onClick={() => handleSocialTracking(x.name)}
                      newPage
                      external
                    >
                      {!!getIcon(x.icon) && (
                        <span className={styles.socialItemIcon}>{getIcon(x.icon)}</span>
                      )}
                      {!!x.name && <span className={styles.socialItemLabel}>{x.name}</span>}
                    </WLink>
                  </li>
                ))}
              </ul>
            )}

            {footerMenu?.children.map((x) => (
              <div key={x.pk} className={`${styles.col} ${styles.footerMenuMobile}`}>
                <div className={`${styles.menu}`}>
                  {x.children?.length > 0 &&
                    x.children.map((y) => (
                      <WLink
                        href={y.url}
                        onClick={() => handleFooterTracking(y.key, x.key)}
                        newPage={y.blank}
                        className={styles.menuItem}
                      >
                        {y.name}
                      </WLink>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </WContainer>
      </div>
      <div className={styles.bottom}>
        <WContainer>
          <div
            dangerouslySetInnerHTML={{
              __html: t(`footer_${process.env.SITE_ID}_${router.locale}`),
            }}
          />
        </WContainer>
      </div>
    </footer>
  )
}

export default Footer
